import * as React from 'react';
import { connect } from 'react-redux';
import * as AOIModule from 'Modules/AOIModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as MapModule from 'Modules/MapModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';

export type State = {
    //
};
export type ConnectedProps = {
    aoiStore: AOIModule.Types.AOIStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

export type DispatchedProps = {
    getAoiList: Function;
    addAoi: Function;
    deleteAoi: Function;
    setActiveAoi: Function;
    showAoiDetailsPopup: Function;
    hideAoiDetailsPopup: Function;
    setMapCenter: Function;
};

export type Props = {
    title: string;
    zone: HistoryModule.EnumTypes.ZonesViewType;
};

class AOI extends React.Component<Props & ConnectedProps & DispatchedProps, State> {
    constructor(props: Props & ConnectedProps & DispatchedProps) {
        super(props);
        this.handleAoiElementClick = this.handleAoiElementClick.bind(this);
    }
    public componentDidMount() {
        if (this.props.aoiStore.aoiList.length === 0) {
            this.props.getAoiList();
        }
    }
    private handleAoiElementClick(aoiDetails: AOIModule.Types.AreaOfInterestDto) {
        const { setActiveAoi, showAoiDetailsPopup, hideAoiDetailsPopup, setMapCenter } = this.props;
        const center = { lat: aoiDetails.multipolygonGeoJson.coordinates[0][0][0][0], lng: aoiDetails.multipolygonGeoJson.coordinates[0][0][0][1] };
        setActiveAoi(aoiDetails);
        hideAoiDetailsPopup();
        setMapCenter(center);

        showAoiDetailsPopup();
    }
    public render() {
        const { aoiStore } = this.props;
        return (
            <div className="poi__element">
                {this.props.aoiStore.aoiList.map((e: AOIModule.Types.AreaOfInterestDto, idx: number) => {
                    return <AoiElement key={idx} aoiDetails={e} onClick={this.handleAoiElementClick} activeAoi={aoiStore.activeAoi} />;
                })}
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        aoiStore: state.aoiStore,
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        getAoiList: () => dispatch(AOIModule.Actions.getAoiList(null)),
        addAoi: (aoiDetails: AOIModule.Types.AddAreaOfInterestRequest) => dispatch(AOIModule.Actions.addAoi(aoiDetails)),
        deleteAoi: (aoiId: number) => dispatch(AOIModule.Actions.deleteAoi(aoiId)),
        setActiveAoi: (aoiDetails: AOIModule.Types.AreaOfInterestDto) => dispatch(AOIModule.Actions.setDetailsForAoiView(aoiDetails)),
        showAoiDetailsPopup: () => dispatch(AOIModule.Actions.showAoiDetailsPopup()),
        hideAoiDetailsPopup: () => dispatch(AOIModule.Actions.hideAoiDetailsPopup()),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center))
    };
}
export default connect(
    mapStateToProps,
    mapDispachToProps
)(AOI) as React.ComponentClass<Props>;

const AoiElement = (props: { aoiDetails: AOIModule.Types.AreaOfInterestDto; onClick: Function; activeAoi?: AOIModule.Types.AreaOfInterestDto }) => {
    const { aoiDetails, activeAoi } = props;
    let classes = 'poidetails';
    if (activeAoi !== null) {
        classes += activeAoi.id === aoiDetails.id ? ' active' : '';
    }
    return (
        <div className={classes} onClick={() => props.onClick(aoiDetails)}>
            <div className="poidetails__title">
                <img src="/images/icons/strefa.svg" width="18" />
                <h5>{aoiDetails.title}</h5>
            </div>
            <div className="poidetails__description">
                <h6 className="poidetails__heading">Adres</h6>
                <p className="poidetails__address">
                    <span>{aoiDetails.address}</span>
                </p>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Map/POIManagement/AOI.tsx